import { render } from "./ArticleCard.vue?vue&type=template&id=0be502dc"
import script from "./ArticleCard.vue?vue&type=script&lang=ts"
export * from "./ArticleCard.vue?vue&type=script&lang=ts"
script.render = render

export default script